/* PD Chambre de princesse : ouverture des cartes produits des points
   (clic, survol sur ordinateur, Échap, clic ailleurs) et maintien à l'écran. */
(function () {
  const MARGIN = 16;
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initChambre(root) {
    if (!root || root.dataset.pdChambreReady) return;
    root.dataset.pdChambreReady = 'true';

    const spots = [...root.querySelectorAll('.pd-chambre__spot')];
    let openSpot = null;
    let hoverTimer = null;

    const place = (spot) => {
      const card = spot.querySelector('.pd-chambre__card');
      const media = root.querySelector('.pd-chambre__media');
      const spotRect = spot.getBoundingClientRect();
      const mediaRect = media.getBoundingClientRect();

      // Côté d'ouverture : vers l'intérieur de la photo
      spot.dataset.side = spotRect.left > mediaRect.left + mediaRect.width / 2 ? 'left' : 'right';
      spot.dataset.v = spotRect.top > mediaRect.top + mediaRect.height / 2 ? 'up' : 'down';

      // Décalage horizontal pour ne jamais sortir de l'écran
      card.style.setProperty('--shift', '0px');
      const rect = card.getBoundingClientRect();
      const maxRight = document.documentElement.clientWidth - MARGIN;
      let shift = 0;
      if (rect.right > maxRight) shift = maxRight - rect.right;
      if (rect.left + shift < MARGIN) shift = MARGIN - rect.left;
      card.style.setProperty('--shift', `${Math.round(shift)}px`);
    };

    const close = (spot) => {
      if (!spot) return;
      spot.classList.remove('is-open');
      spot.querySelector('.pd-chambre__dot').setAttribute('aria-expanded', 'false');
      spot.querySelector('.pd-chambre__card').hidden = true;
      if (openSpot === spot) openSpot = null;
    };

    const open = (spot) => {
      if (openSpot && openSpot !== spot) close(openSpot);
      spot.classList.add('is-open');
      spot.querySelector('.pd-chambre__dot').setAttribute('aria-expanded', 'true');
      spot.querySelector('.pd-chambre__card').hidden = false;
      openSpot = spot;
      place(spot);
    };

    spots.forEach((spot) => {
      const dot = spot.querySelector('.pd-chambre__dot');

      dot.addEventListener('click', (event) => {
        event.stopPropagation();
        if (openSpot === spot && !hoverQuery.matches) {
          close(spot);
        } else {
          open(spot);
        }
      });

      spot.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        clearTimeout(hoverTimer);
        open(spot);
      });

      spot.addEventListener('mouseleave', () => {
        if (!hoverQuery.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => close(spot), 250);
      });
    });

    document.addEventListener('click', (event) => {
      if (openSpot && !openSpot.contains(event.target)) close(openSpot);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !openSpot) return;
      const dot = openSpot.querySelector('.pd-chambre__dot');
      close(openSpot);
      dot.focus();
    });

    window.addEventListener('resize', () => {
      if (openSpot) place(openSpot);
    });

    // Éditeur de thème : sélectionner un bloc ouvre sa carte
    root.addEventListener('shopify:block:select', (event) => {
      const spot = spots.find((s) => s.dataset.blockId === event.detail.blockId);
      if (spot) open(spot);
    });
    root.addEventListener('shopify:block:deselect', () => close(openSpot));
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-chambre]').forEach(initChambre);

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
